import { array } from 'prop-types';
import { Image } from 'cloudinary-react';

import { Carousel, CarouselItem } from 'components/common/Carousel';
import useScreen from '@/hooks/useScreen';
import cx from '@/lib/cx';

const CampaignPagePhotoGalleryCarousel = ({ images }) => {
  const isMobile = !useScreen().md;
  return (
    <div className="mt-4 md:mt-10">
      <Carousel
        items={images}
        renderItem={({ item, isSnapPoint }) => (
          <CarouselItem key={item} isSnapPoint={isSnapPoint}>
            <div className={cx('w-full flex items-center justify-center h-[300px] md:h-[550px]')}>
              <Image
                publicId={item}
                alt="photo-gallery"
                width="auto"
                height={isMobile ? 1000 : 1200}
                crop="scale"
                resize="limit"
                quality="auto"
                className="w-full h-full object-contain object-center"
              />
            </div>
          </CarouselItem>
        )}
      />
    </div>
  );
};

CampaignPagePhotoGalleryCarousel.propTypes = {
  images: array.isRequired,
};

export default CampaignPagePhotoGalleryCarousel;
